import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import clsx from 'clsx';
import * as Colors from '../../../theme/colors';
import FormPageHeaderBase from './FormPageHeaderBase';
import { FormPageHeaderProps } from '../formPageTypes';
import { DividersAndCardBorders } from '../../../theme/colors';

const useStyles = makeStyles(() =>
  createStyles({
    containedPageHeader: {
      borderBottom: `1px solid ${DividersAndCardBorders}`,
    },
    unsavedChanges: {
      backgroundColor: Colors.HoverBackground,
    },
  }),
);
const ContainedFormPageHeader: React.FC<FormPageHeaderProps> = props => {
  const classes = useStyles();
  const { showActions } = props;
  return (
    <FormPageHeaderBase
      className={clsx(classes.containedPageHeader, {
        [classes.unsavedChanges]: showActions,
      })}
      {...props}
    />
  );
};

export default ContainedFormPageHeader;
